import { render, staticRenderFns } from "./MultiColumnBlock.vue?vue&type=template&id=c4a5a5dc&scoped=true&"
import script from "./MultiColumnBlock.vue?vue&type=script&lang=ts&"
export * from "./MultiColumnBlock.vue?vue&type=script&lang=ts&"
import style0 from "./MultiColumnBlock.vue?vue&type=style&index=0&id=c4a5a5dc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4a5a5dc",
  null
  
)

export default component.exports